import MenuList from '@mui/material/MenuList';
import Popper from '@mui/material/Popper';
import Grow from '@mui/material/Grow';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import { PopperProps } from '@mui/material/Popper/Popper';

interface MenuListDecoratorProps {
  open: boolean,
  anchorEl: HTMLButtonElement | null,
  onClickAway: (event: any) => void,
  placement?: PopperProps['placement'],
  width?: number,
  maxHeight?: number,
  children: React.ReactNode,
}

// See more: https://material-ui.com/components/menus/#menulist-composition
export const MenuListDecorator = (props: MenuListDecoratorProps) => {
  const {
    open,
    anchorEl,
    onClickAway,
    children,
    placement,
    width,
    maxHeight,
  } = props;
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      role={undefined}
      transition
      disablePortal
      placement={placement ?? 'bottom-end'}
      modifiers={[
        { name: 'preventOverflow', enabled: false },
        { name: 'flip', enabled: false },
      ]}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: placement === 'bottom-end' ? 'top left' : 'center bottom' }}
        >
          <Paper>
            <ClickAwayListener onClickAway={onClickAway}>
              <MenuList
                sx={{
                  overflow: 'auto',
                  width,
                  maxHeight,
                }}
              >
                {children}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};
